'use client'

import { useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'
import posthog from 'posthog-js'

const ddApplicationId = 'ce64c316-1463-4863-bb43-6fa18a9d825a'
const ddClientToken = 'pub87a423de27fa6fd3781ffe84e57ab28f'

export function DatadogRum({ env }: { env?: string }) {
  useEffect(() => {
    if (!env || datadogRum.getInitConfiguration()) return

    const ddVersion = process.env.NEXT_PUBLIC_DD_VERSION
    if (ddVersion) {
      process.env.DD_VERSION = process.env.NEXT_PUBLIC_DD_VERSION
    }
    console.debug(`datadogRum.init({env: '${env}', version: '${ddVersion}'})`)
    datadogRum.init({
      beforeSend: event => {
        if (event.type === 'error') {
          const error = event.error
          error.fingerprint = `${error.name}: ${error.message}`
        }
        return true
      },
      proxy: options => {
        const path = options.path.endsWith('/') ? options.path : `${options.path}/`
        const qs = options.parameters ? `?${options.parameters}` : ''
        // noinspection UnnecessaryLocalVariableJS
        const proxyUrl = `/dd-browser-intake${path}?qs=${qs}`
        // console.debug('dataDogRum.proxyUrl', proxyUrl)
        return proxyUrl
      },
      applicationId: ddApplicationId,
      clientToken: ddClientToken,
      site: 'us3.datadoghq.com',
      service: 'corsica',
      env: env,
      version: ddVersion,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [
        {
          match: /^https:\/\/[^\/]+\.auntygrace\.com\.au/,
          propagatorTypes: ['tracecontext', 'datadog'],
        },
      ],
      traceSampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackEarlyRequests: true,
      trackUserInteractions: true,
    })

    posthog.onFeatureFlags(() => {
      const flags = posthog.featureFlags.getFlagVariants()
      const flagsList = Object.entries(flags)
      console.debug(`posthog.onFeatureFlags() ${flagsList.length} found`)
      for (const [flag, variant] of flagsList) {
        console.debug(`datadogRum.addFeatureFlagEvaluation('posthog-${flag}', '${variant}')`)
        datadogRum.addFeatureFlagEvaluation(`posthog-${flag}`, variant)
      }
    })
  }, [env])

  return null
}
